import { Component, Input, SimpleChanges } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { BrdsqlService } from 'src/app/core/services/brdsql.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomService } from 'src/app/core/services/custom.service';

@Component({
  selector: 'app-brd-cpc-form',
  templateUrl: './brd-cpc-form.component.html',
  styleUrls: ['./brd-cpc-form.component.css']
})
export class BrdCpcFormComponent {

  @Input() receivedDate: string | null = null;
  private subscription: Subscription;
  brddata?: any = [];
  reportdate: string = '';
  form: FormGroup;
  dateLabel: string | null = null;

  constructor(
    private brdservice: BrdsqlService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private custService: CustomService,
  ) {
    this.form = this.fb.group({
      id: ['', Validators.required],
      trash_today_brr: [0, Validators.required],
      trash_brr: [0, [Validators.required]],
      sugarperccs_today_brr: [0, [Validators.required]],
      sugarperccs_brr: [0, [Validators.required]],
      sugarperton_today_brr: [0, [Validators.required]],
      sugarperton_brr: [0, [Validators.required]],
      outstandingDebt_target: [0, [Validators.required]],
      outstandingDebt_today: [0, [Validators.required]],
      outstandingDebt_amount: [0, [Validators.required]],
      lossCutting_target: [300, [Validators.required]],
      lossCutting: [0, [Validators.required]],
    });
  }

  ngOnInit(): void { 
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['receivedDate'] && this.receivedDate.trim()) {
      const date: string = this.receivedDate;
      this.dateLabel = this.custService.getThaiDateToday(date)
      this.getBrdDiaryCPC(date);
    }
  }  

  async getBrdDiaryCPC(date: string) {
    this.spinner.show()
    this.subscription = await this.brdservice.getBrdCPCDiaryReportData(date)
    .subscribe({
      next:(res) => {
        // console.log('res :' ,res);
        if(res.code == "EREQUEST") {
          alert('!! ไม่มีข้อมูล หรือ เกิดความผิดพลาดในการติดต่อกับฐานข้อมูล..');
          this.form.reset();
          this.brddata = [];
        } else {
          if(res.recordset.length !== 0) {
            this.brddata = res.recordset[0]
            console.log('brd cpc data :' ,this.brddata);
            this.form.patchValue(this.brddata);  // เติมค่าเฉพาะฟิลด์ที่มี
            // this.form.setValue(this.brddata);  // ต้องใส่ค่าครบทุกฟิลด์
          } else {
            alert('!!ไม่พบข้อมูลของวันที่ดังกล่าว..');
          }

        }
      },error(err) {
        console.log('err:' ,err)
      },complete:() => {
        // console.log('complete');
        this.spinner.hide();
      },
    })
  }

  async onSubmit() {
    console.log('Form Data:', this.form.value);
    if (this.form.valid) {
      this.spinner.show()
      this.subscription = await this.brdservice.saveUpdateCpcDiaryReport(this.form.value)
      .subscribe({
        next:(res) => {
          console.log('res :' ,res);
          if(res.rowsAffected[0] == 1) {
            alert('บันทึกข้อมูลสำเร็จ!');
            this.form.reset();
          }
        },error(err) {
          console.log('err:' ,err)
        },complete:() => {
          // console.log('complete');
          this.spinner.hide();
        },
      })
    } else {
      alert('กรุณากรอกข้อมูลให้ครบถ้วน');
    }
  }  
  
  ngOnDestroy(): void {
    // Unsubscribe เมื่อ Component ถูกทำลาย
    if (this.subscription) {
      this.subscription.unsubscribe();
      console.log('Unsubscribed!');
    }
  }   

}
